<div class="vertical-line"></div>


<div class=" reservation_step ">
  <ul>
    <li class="left-link ">

      <span>1.</span> Personal
    </li>
    <li>

      <span>2.</span> Conference
    </li>
    <li routerLinkActive="active ">

      <span>3.</span> Accommodation
    </li>
    <li>

      <span>4.</span> Room Choice
    </li>
    <li class="active">

      <span>5.</span> Tour
    </li>
    <li class="right-link">

      <span>6.</span> Confirm
    </li>
  </ul>
</div>

<div class="info ">
  <form [formGroup]="tourInfoForm" (submit)="submitTourInfo() ">

    <div>
      <h3>Select Tour to include:</h3>
      <span class="checkbox ">
        <input formControlName="includeSowetoTour" type="checkbox" id="sowetoTour ">
        <label for="sowetoTour ">Include Soweto Tour? - $50</label>
      </span>
      <span class="checkbox ">
        <input formControlName="includeUnionBuildingTour" type="checkbox" id="unionBuildingTour ">
        <label for="unionBuildingTour ">Include Union Building Tour? - $40</label>
      </span>
      <span class="checkbox ">
        <input formControlName="includeSunCityTour" type="checkbox" id="sunCityTour ">
        <label for="sunCityTour ">Include Sun City Tour? - $75</label>
      </span>
      <span class="checkbox ">
        <input formControlName="includeGoldReefCityTour" type="checkbox" id="goldReefCity ">
        <label for="goldReefCity ">Include Gold Reef City Tour? - $65</label>
      </span>
    </div>

    <div>
      <button class="btn btn-success" (click)="cancel() ">Cancel</button>
      <button class="btn btn-info" type="submit">Next</button>
    </div>
  </form>
</div>


// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/booking/form-components/tourinfo/tourinfo.component.html